<template>
	<section class="section-container" v-if="!is_supplier">
		<div class="content-wrapper">
			<div class="content-heading" v-if="parttype.id">
				{{ $t('parttype.edit') }}
			</div>
			<div class="content-heading" v-else>
				{{ $t('parttype.add') }}
			</div>
			<div class="row">
				<div class="col-xl-4">
					<div class="card card-default">
						<div class="card-body">
							<form @submit.prevent="save" class="form-modal form-parttype">
								<div class="form-group">
									<label for="name">{{ $t('parttype.group') }} *</label>
									<input
											:class="{'parsley-error': errors.name}"
											autocomplete="off"
											class="form-control"
											id="name"
											:placeholder="$t('parttype.insert-group')"
											type="text"
                      disabled="disabled"
											v-model="parttype.name">
									<ul class="parsley-errors-list filled" v-if="errors.name">
										<li class="parsley-required">{{ errors.name[0] }}</li>
									</ul>
								</div>
								<div class="form-group">
									<label for="category">{{ $t('parttype.category') }}</label>
									<multiselect
											v-model="parttype.category"
											:tag-placeholder="$t('parttype.role')"
											:placeholder="$t('parttype.role')"
											label="name"
											track-by="name"
											:options="categories"
											:multiple="false">
										<template slot="noOptions">{{ $t('global.no-options') }}</template>
									</multiselect>

									<ul class="parsley-errors-list filled" v-if="errors.role">
										<li class="parsley-required">{{ errors.role[0] }}</li>
									</ul>
								</div>

								<buttons url="parttypes"/>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import api from '@/api'
	import Buttons from '@/components/Buttons.vue'
	import message from '@/message'
	import More from '@/components/More.vue'
	import {parseApiError} from '@/utils'
	import Multiselect from 'vue-multiselect'


	const getData = (id, next) => {
		if (id) {
			Promise.all([
				api.get(`/part_types/${id}/`),
				api.get(`/categories/?page_size=0`)
			])
				.then(([parttype, categories]) => {
					let categoriesList = [];
					let categoryNames = [];
					categories.data.forEach(r => {
						categoriesList.push(r);
						categoryNames[r.id] = r.name;
					})
					parttype.data.category = {
						id:parttype.data.category,
						name:categoryNames[parttype.data.category]
					};
					next({
						categories: categoriesList,
						parttype: parttype.data
					})
				})
		} else {
			Promise.all([
				api.get(`/categories/?page_size=0`)
			])
				.then(([categories]) => {
					let categoriesList = [];
					categories.data.forEach(r => {
						categoriesList.push(r);
					})
					next({
						categories: categoriesList,
						parttype: {
							name: '',
							is_active: true,
							category: '',
						}
					})
				})
		}
	}

	export default {
		components: {
			buttons: Buttons,
			more: More,
			Multiselect
		},
		data() {
			return {
				parttype: {
					category: '',
				},
				more: null,
				errors: {},
				categories: []
			}
		},
		computed: {
			is_supplier() {
				return this.$store.getters.user_group === 'Supplier'
			}
		},
		mounted() {
			this.$parent.menu = 'setup'
			this.$parent.submenu = 'parttypes'
			this.$i18n.locale = this.$store.getters.language
		},
		methods: {
			save() {
				this.errors = {}

				if (this.parttype.id) {
					this.parttype.category = this.parttype.category.id;
					api.patch(`/part_types/${this.parttype.id}/`, this.parttype)
						.then(() => {
							message.success('Part type changed')
							this.$router.push({name: 'parttypes'})
						})
						.catch(error => {
							let errors = parseApiError(error, this.$i18n)
							if (error.response && error.response.status === 400) {
								this.errors = errors
							} else {
								message.error(errors)
							}
						})
				} else {
					api.post('/part_types/', this.parttype)
						.then(() => {
							message.success('Part type added')
							if (this.more) {
								this.parttype.name = ''
								this.parttype.category = ''
								this.parttype.is_active = true
								this.$router.push({name: 'parttype_add'})
							} else {
								this.$router.push({name: 'parttypes'})
							}
						})
						.catch(error => {
							let errors = parseApiError(error, this.$i18n)
							if (error.response && error.response.status === 400) {
								this.errors = errors
							} else {
								message.error(errors)
							}
						})
				}
			}
		},
		beforeRouteEnter(to, from, next) {
			getData(to.params.id, data => {
				next(vm => {
					Object.assign(vm.$data, data)
				})
			})
		},
		beforeRouteUpdate(to, from, next) {
			getData(to.params.id, data => {
				Object.assign(this.$data, data)
				next()
			})
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/Parttype.vue